// extracted by mini-css-extract-plugin
export default {"lineBreak":"LineBreak__lineBreak___k_O4F"};